import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import "aos/dist/aos.css";

function RoboticProcessAutomation() {

  useEffect(() => {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanes = document.querySelectorAll('.tab-pane');
    
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));
        this.classList.add('active');

        const tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
      });
    });
  }, []);

  useEffect(()=>{
     AOS.init({duration:1000, delay:true});
  },[])

  return (
    <div className="webdev-page" style={{overflowX:"hidden"}}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">Robotic Automation</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section rpa-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Stand out online, get ahead of the competition</h2>
            <p className="intro-text">
            Robotic Process Automation (RPA) is revolutionizing business operations by automating repetitive tasks, streamlining workflows, and driving operational excellence. By leveraging intelligent bots, organizations can unlock new levels of productivity, minimize errors, and empower teams to focus on strategic initiatives.            </p>
          </div>
            </div>
          <div className="intro-image rpa-graphic">
            {/* Graphic content removed as requested */}
          </div>
        </div>
      </section>

      {/* Our RPA Services Section */}
      <section className="webdev-services-section rpa-services">
        <div className="container">
          <div className="section-header">
            <h2>Our RPA Services</h2>
            <p className="section-description">
              Comprehensive automation solutions to transform your business operations
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-dealy="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Process Assessment</h3>
              <p>Evaluate your business processes to identify automation opportunities with the highest ROI potential.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>Bot Development</h3>
              <p>Custom-built bots tailored to your unique business processes and operational needs.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-sitemap"></i>
              </div>
              <h3>Workflow Automation</h3>
              <p>End-to-end automation of complex workflows across systems and applications.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Intelligent Automation</h3>
              <p>Integrate RPA with AI and ML to automate cognitive, decision-based tasks.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-pie"></i>
              </div>
              <h3>Analytics & Reporting</h3>
              <p>Automate reporting and gain actionable insights to track performance and ROI.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <h3>RPA Maintenance</h3>
              <p>Continuous monitoring, optimization, and support for peak automation performance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Implementation Process */}
      <section className="design-process-section rpa-process">
        <div className="container">
          <div className="section-header">
            <h2>Our RPA Implementation Process</h2>
            <p className="section-description">
              A structured approach to transforming your business operations through automation
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Process Discovery & Assessment",
                text: "We identify high-impact automation opportunities with maximum ROI potential."
              },
              {
                num: 2,
                title: "Process Design & Documentation",
                text: "Tailored bots are developed to meet your exact business needs and workflows."
              },
              {
                num: 3,
                title: "Bot Development",
                text: "Tailored bots are developed to meet your exact business needs and workflows."
              },
              {
                num: 4,
                title: "Testing & Validation",
                text: "Thorough testing ensures reliability, accuracy, and robust exception handling."
              },
              {
                num: 5,
                title: "Deployment",
                text: "We integrate RPA into your production environment with minimal disruption."
              },
              {
                num: 6,
                title: "Monitoring & Optimization",
                text: "Performance is continuously monitored and enhanced for maximum efficiency."
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-dealy="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Business Benefits Section */}
      <section className="webdev-services-section blockchain-services">
        <div className="container">
          <div className="section-header">
            <h2>Benefits of RPA Implementation</h2>
            <p className="section-description">
              Discover how RPA can transform your business operations and deliver tangible results
            </p>
          </div>

         <div className="services-grid" data-aos="fade-up-left" data-aos-dealy="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-tachometer-alt"></i>
              </div>
              <h3>Increased Efficiency</h3>
              <p>Automate repetitive tasks to operate 24/7 without downtime.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-hand-holding-usd"></i>
              </div>
              <h3>Cost Reduction</h3>
              <p>Reduce operational costs and maximize ROI by reallocating resources</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-check-double"></i>
              </div>
              <h3>Improved Accuracy</h3>
              <p>Eliminate errors caused by manual data entry and processing.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Enhanced Employee Experience</h3>
              <p>Free up staff to focus on strategic and creative tasks.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3>Faster Processing</h3>
              <p>Accelerate workflows and significantly cut turnaround times.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Scalability</h3>
              <p>Quickly adapt and scale automation as business demands grow</p>
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="use-cases-section">
        <div className="container">
          <div className="section-header">
            <h2>RPA Use Cases Across Industries</h2>
            <p className="section-description">
              How different sectors are leveraging RPA to transform their operations
            </p>
          </div>

          <div className="use-cases-tabs">
            <div className="tabs-navigation">
              <button className="tab-button active" data-tab="finance">Finance & Banking</button>
              <button className="tab-button" data-tab="healthcare">Healthcare</button>
              <button className="tab-button" data-tab="retail">Retail & E-commerce</button>
              <button className="tab-button" data-tab="hr">Human Resources</button>
            </div>
            
            <div className="tabs-content" data-aos="fade-up" data-aos-dealy="200">
              <div className="tab-pane active" id="finance">
                <div className="tab-content-inner">
                  <div className="tab-image">
                    <i className="fas fa-university"></i>
                  </div>
                  <div className="tab-text">
                    <h3>Finance & Banking</h3>
                    <ul className="use-case-list">
                      <li>Automated account reconciliation and financial reporting</li>
                      <li>Customer onboarding and KYC process automation</li>
                      <li>Mortgage and loan processing automation</li>
                      <li>Fraud detection and compliance monitoring</li>
                      <li>Invoice processing and accounts payable automation</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="tab-pane" id="healthcare">
                <div className="tab-content-inner">
                  <div className="tab-image">
                    <i className="fas fa-heartbeat"></i>
                  </div>
                  <div className="tab-text">
                    <h3>Healthcare</h3>
                    <ul className="use-case-list">
                      <li>Patient data management and record updates</li>
                      <li>Claims processing and billing automation</li>
                      <li>Appointment scheduling and reminders</li>
                      <li>Inventory management for medical supplies</li>
                      <li>Compliance reporting and documentation</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="tab-pane" id="retail">
                <div className="tab-content-inner">
                  <div className="tab-image">
                    <i className="fas fa-shopping-cart"></i>
                  </div>
                  <div className="tab-text">
                    <h3>Retail & E-commerce</h3>
                    <ul className="use-case-list">
                      <li>Inventory management and stock level monitoring</li>
                      <li>Order processing and fulfillment automation</li>
                      <li>Customer data management and segmentation</li>
                      <li>Pricing updates and competitive analysis</li>
                      <li>Returns processing and customer service automation</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="tab-pane" id="hr">
                <div className="tab-content-inner">
                  <div className="tab-image">
                    <i className="fas fa-user-tie"></i>
                  </div>
                  <div className="tab-text">
                    <h3>Human Resources</h3>
                    <ul className="use-case-list">
                      <li>Employee onboarding and offboarding processes</li>
                      <li>Payroll processing and benefits administration</li>
                      <li>Resume screening and candidate shortlisting</li>
                      <li>Time and attendance tracking</li>
                      <li>Employee data management and reporting</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      {/* CTA Section */}
      <section className="cta-section mt-5 rpa-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Automate Your Business Processes?</h2>
            <p>Let's unlock the potential of RPA to streamline operations and drive efficiency in your organization.</p>
            <a href="/contact" className="cta-button">Schedule Your RPA Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RoboticProcessAutomation;
